import { Filter } from "lucide-react";
import { GlobalIntent, intentIcons } from "@/hooks/useGlobalIntents";

interface GlobalFilterChipProps {
  selectedIntents: GlobalIntent[];
  hasActiveFilters: boolean;
  onClick: () => void;
}

export const GlobalFilterChip = ({
  selectedIntents,
  hasActiveFilters,
  onClick,
}: GlobalFilterChipProps) => {
  // Show icons of selected intents
  const displayIcons = selectedIntents.slice(0, 3).map((i) => intentIcons[i]).join("");

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-sm font-medium transition-all ${
        hasActiveFilters
          ? "border-primary bg-primary/10 text-primary"
          : "border-border bg-card hover:border-primary/50"
      }`}
    >
      <Filter className="w-3.5 h-3.5" />
      {displayIcons && <span>{displayIcons}</span>}
      {hasActiveFilters && (
        <span className="w-1.5 h-1.5 rounded-full bg-primary" />
      )}
    </button>
  );
};
